import classNames from "classnames";
import { ReactNode } from "react";
import { createUseStyles } from "react-jss";
import SectionBlock from "../SectionBlock";

interface Props {
  className?: string;
  left: ReactNode;
  right: ReactNode;
  header?: string;
  variant?: string;
  id?: string;
}

const useStyles = createUseStyles({
  root: {
    "& *": {
      marginTop: "0px",
    },
  },
  fiftyfiftySection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    "@media (max-width: 1480px)": {
      flexDirection: "column",
    },
  },
  left: {
    "& > img": {
      backgroundSize: "cover",
      width: "100%",
    },
  },
  right: {
    "& h2": {
      marginBottom: "30px",
    },
    "@media (max-width: 1024px)": {
      marginTop: "30px",
    },
  },
  column: {
    flexBasis: "49%",
  },
});

const FiftyFiftySection = ({
  className,
  header,
  left,
  right,
  variant,
  id,
}: Props) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className)} id={id}>
      <SectionBlock header={header} variant={variant}>
        <div
          className={classes.fiftyfiftySection}
          style={{ marginTop: header ? "50px" : "0px" }}
        >
          <div className={classNames(classes.left, classes.column)}>{left}</div>
          <div className={classNames(classes.right, classes.column)}>
            {right}
          </div>
        </div>
      </SectionBlock>
    </div>
  );
};

export default FiftyFiftySection;
